import React, { useEffect } from "react";
import { IconButton, Paper } from "@mui/material";
import ThumbNailImage from "./ThumbNailImage";
import { useDispatch, useSelector } from "react-redux";
import { setOpen, setSimilarSkusDetails } from "../../store/ShelfView/popover";
import axios from "axios";
import SimilarSkusList from "./SimilarSkusList";
import PackShotThumbnailData from "./PackShotThumbnailData";
import CloseIcon from "@mui/icons-material/Close";

const PopupRenderedData = ({ anchor, setAnchor, ...props }) => {
  const dispatch = useDispatch();
  // console.log(props)
  const { similarSkusDetails } = useSelector((state) => state.popoverStore);

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .post("/groupData/getGroupSkusData", {
          sub_sku_id: props.predictions.sub_sku_id,
        })
        .then((res) => {
          dispatch(setSimilarSkusDetails(res.data));
          //console.log("data fetched");
        })
        .catch((err) => {
          console.log(err);
        });
    };
    fetchData();
  }, [props.predictions.sub_sku_id]);

  const handleOpen = (event) => {
    if (event.target.closest(".close-button")) {
      // console.log(event)
      setAnchor(anchor ? null : event.currentTarget);
      //console.log(Boolean(anchor))
      dispatch(setOpen(Boolean(anchor ? null : event.currentTarget)));
    }
  };
  // console.log(anchor,"rendered data")
  return (
    <>
      <Paper
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "1rem",
          width: "90%",
          margin: "0.6rem",
          padding: "0.2rem",
          marginTop:"1rem"
        }}
        sx={{
          "@media screen and (max-height:1200px)": {
            margin: "0.6rem",
            marginTop: "1rem",
          },
          // "@media screen and (max-height: 990px)": {
          //   marginTop: "2rem",
          //  height:"85vh"
          // },
          // "@media screen and (max-height: 700px)": {
          //   width: "60%",
          // },
          // "@media screen and (max-height: 600px)": {
          //   width: "75%",
           
          // },
          
        }}
      >
        {/* <div style={{ flex: 1 }}> */}
        <div>
          <ThumbNailImage {...props} />
        </div>
        {/* <div style={{ flex: 1 ,width:"100%"}}> */}
        {/* <div> */}
        <PackShotThumbnailData {...props} />

        {/* </div> */}
        <SimilarSkusList similarSkusDetails={similarSkusDetails} />
        {/* </div> */}
      </Paper>
    </>
  );
};

export default PopupRenderedData;
